import axios from 'axios';

export const LOAD_BRAND = 'LOAD_BRAND';

export const loadBrand = merchantId => async (dispatch, getState) => {
  try {
    const hostname = window.location.hostname;
    const isLocal = hostname === '127.0.0.1' || hostname === 'localhost';
    const localhost = isLocal && 'tunl';
    const domain = hostname.split('.').at(-2);
    const brandKey = localhost || domain || hostname;
    const response = await axios.get(`/api/brand/${brandKey}`);

    dispatch({ type: LOAD_BRAND, payload: response.data });
  } catch (error) {
    console.log(error);
    //dispatch({type: LOCATION_ERROR, payload: error.response });
  }
};
